import { useCallback } from "react";

const EventEmitter = {
  events: {},
  dispatch: function (event, data) {
    if (!this.events[event]) return;
    this.events[event].forEach((callback) => callback(data));
  },
  subscribe: function (event, callback) {
    if (!this.events[event]) this.events[event] = [];
    this.events[event].push(callback);
  },
};

export default EventEmitter;

export const handleToolTip = (pickRandomTown) => {
  const toolTipPortion = document.querySelector("#tooltip-portion");
  const townElement = document.querySelector(
    `[data-townid="${pickRandomTown?.id}"]`
  );
  const townElementPosition = townElement.getBoundingClientRect();

  toolTipPortion.setAttribute(
    "style",
    `
      top: ${
        townElementPosition.y -
        toolTipPortion.clientHeight -
        townElementPosition.height / 6
      }px;
      left: ${
        townElementPosition.right -
        toolTipPortion.clientWidth / 2 -
        townElementPosition.width / 2
      }px;
      opacity: 1;
      pointer-events: auto;
      `
  );

  toolTipPortion.classList.remove("pointer-events-none", "opacity-0");
};
